import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

import { DropDownComponentBase } from './drop-down.base.component';

import { CommonService } from '../../_services';
import { ICountry, IGeographicRegion, ICity } from '../../_entities';

@Component({
    selector: 'geographic-region-dropdown',
    template: require('./dropdown.template.html'),
    styles: ['input[type=text] { margin-top:10px; }']
})
export class GeographicRegionDropDownComponent extends DropDownComponentBase<IGeographicRegion> {
    private country: ICountry;

    constructor(private commonService: CommonService) {
        super();
    }

    ngOnInit() {
        this.isDisabled = !this.country;
    }
    getDisplayValue(item: IGeographicRegion) {
        return item.name;
    }

    getItems(): Promise<IGeographicRegion[]> {
        if (!this.country) {
            return null;
        }

        return this.commonService.getRegionsInCountry(this.country.code);
    }
    mapItem(items: IGeographicRegion[], item: IGeographicRegion): IGeographicRegion {
        return items.find(x => x.country.code === item.country.code && x.name === item.name);
    }
    onItemSelected(item: IGeographicRegion) {
        this.selectedItemChange.emit(item);
    }

    @Input("country") set countryBinding(val: ICountry) {
        if ((!this.country && val) || (val && val.code !== this.country.code)) {
            this.country = val;
        } else if (!val) {
            this.country = null;
        }
        this.updateItemList();
        if (!this.country || (this.selectedItem && this.country.code !== this.selectedItem.country.code)) {
            this.setSelectedItem(null);
        }
        this.isDisabled = !this.country;
    }
    @Input("selectedRegion") set selectedItemBinding(val: IGeographicRegion) {
        if (val != this.selectedItem)
            this.setSelectedItem(val);
    }
    @Output("selectedRegionChange") selectedItemChange = new EventEmitter<IGeographicRegion>();
    
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/components/geographic-region-dropdown.component.ts